// src/utils/validationSchemas.js
import { z } from "zod";

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, "Email is required")
    .email("Please enter a valid email address"),
  password: z
    .string()
    .min(1, "Password is required")
    .min(6, "Password must be at least 6 characters"),
});

export const signupSchema = z
  .object({
    first_name: z
      .string()
      .min(1, "First name is required")
      .min(2, "First name must be at least 2 characters"),
    last_name: z
      .string()
      .min(1, "Last name is required")
      .min(2, "Last name must be at least 2 characters"),
    // email — hidden for now, made optional
    email: z.string().email("Please enter a valid email address").optional().or(z.literal("")),
    phone: z
      .string()
      .min(1, "Phone number is required")
      .regex(/^\d+$/, "Phone number must contain only numbers")
      .min(10, "Phone number must be exactly 10 digits")
      .max(10, "Phone number must be exactly 10 digits"),
    // password & confirmPassword — hidden for now, made optional
    password: z.string().optional(),
    confirmPassword: z.string().optional(),
    agreeToDisclaimer: z.boolean().refine((val) => val === true, {
      message: "You must agree to the disclaimer to continue",
    }),
  });
// Password match refine — commented out since password fields are hidden
// .refine((data) => data.password === data.confirmPassword, {
//   message: "Passwords do not match",
//   path: ["confirmPassword"],
// });

export const loginDefaultValues = {
  email: "",
  password: "",
};

export const signupDefaultValues = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  agreeToDisclaimer: false,
};
